export class FormulaPlanDetails {
  constructor({
    id = null,
    planCode = '',
    planTime = '', //上料日期
    matCode = '',
    matName = '',
    invAmount = '', //库存量
    formula = '', //配比比例
    dayAmount = '', // 日配比量 
    days = '', // 可用天数
    matBinNumber = '' // 料仓号




  } = {}) {
    this.id = id;
    this.planCode = planCode;
    this.planTime = planTime;
    this.matCode = matCode;
    this.matName = matName;
    this.invAmount = invAmount;
    this.formula = formula;
    this.dayAmount = dayAmount;
    this.days = days;
    this.matBinNumber = matBinNumber;
  }
}
export function gridFields() {
  return Object.freeze([
    {
      key: 'planCode',
      label: 'lbl.formulaPlan.planCode',
      sortable: true,
      uneditable: true,
      notInTable:true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'planTime',
      label: 'lbl.formulaPlan.planTime',
      notInTable: true,
      uneditable: true,
      sortable: true,
      form: {
        type: 'datepicker'
      }
    },

    {
      key: 'matName',
      label: 'lbl.formulaPlan.matName',
      sortable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/material/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'material', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "matName", // 显示的属性的名称
          submitProp: "matName" // 提交的属性
        }
      }
    },
    {
      key: 'matCode',
      label: 'lbl.formulaPlan.matCode',
      // notInTable: true,
      // uneditable:true,
      sortable: true,
      form: {
        type: 'dimSearch',
        url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/material/findAll',
        config: {
          validate: "", // 参数检查，可以是正则表达式等
          bindId: 'material', // 绑定的 id, (id 相同的对象会被绑定)
          bindProp: "matCode", // 显示的属性的名称
          submitProp: "matCode" // 提交的属性
        }
      }
    },
    {
      key: 'grade',
      label: 'lbl.formulaPlan.grade',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'moisture',
      label: 'lbl.formulaPlan.moisture',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'batch',
      label: 'lbl.formulaPlan.batch',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'formula',
      label: 'lbl.formulaPlan.formula',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'invAmount',
      label: 'lbl.formulaPlan.invAmount',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'dayAmount',
      label: 'lbl.formulaPlan.dayAmount',
      sortable: true,
      uneditable:true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'days',
      label: 'lbl.formulaPlan.days',
      sortable: true,
      uneditable:true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'matBinNumber',
      label: 'lbl.formulaPlan.matBinNumber',
      sortable: true,
      uneditable: true,
      form: {
        type: 'input'
      }
    }
  ]);
}

export const fields = Object.freeze(Object.keys(new FormulaPlanDetails()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.matCodeFilter',
  'filter.matNameFilter',
  'filter.planCodeFilter',

];
export const filter = {
  'matCodeFilter': "",
  'matNameFilter': "",
  'planCodeFilter': "",
  


};